<div *transloco="let t; prefix: 'checkout.shipping'" class="text-xl font-medium break-words text-gray-900 mb-4 px-4">{{ t('title') }}</div>

@if (!(signedIn$ | async)) {
    <div *transloco="let t; prefix: 'checkout'" class="w-full border border-gray bg-main rounded-xl p-6 mb-8">
        <h2 class="text-lg font-semibold">{{ t('recepient.form.emailAddress.loginToPlaceOrder') }}</h2>
        <div class="w-[360px] mx-auto">
            <vsf-sign-in
                [navigateToOnSuccess]="['/checkout']"
                [displayRegisterLink]="false">
            </vsf-sign-in>
        </div>
    </div>
}

<div class="w-full border border-gray bg-main rounded-xl p-6">
    @if ((signedIn$ | async) && (customerAddresses$ | async)?.length > 0) {
        <div *transloco="let t; prefix: 'checkout.shipping'" class="mb-8">
            <h2 class="text-lg font-medium break-words text-gray-900">
                {{ t('addressType') }}  
            </h2>
            <vsf-radio-card-fieldset
                [idFn]="getId"
                [selectedItemId]="customerAddressId"
                (selectItem)="setAddress($event.id)"
            >
                <div class="mt-4 grid grid-cols-1 lg:gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                    @for (method of (customerAddresses$ | async); track $index) {
                        <vsf-radio-card [item]="method">
                            <span class="block text-sm font-medium break-words text-gray-900">
                                <!-- {{ method.fullName }} -->
                                @if(method.defaultShippingAddress === true) {
                                    <span class="border-accent rounded-lg p-1 text-accent border-2">{{ t('shipping')}}</span>
                                }
                                @if(method.defaultBillingAddress === true) {
                                    <span class="border-accent rounded-lg p-1 text-accent border-2">{{ t('billing')}}</span>
                                }
                            </span>
                            <span class="mt-6 text-sm text-gray-900">
                                <!-- <p>{{ method.company }}</p> -->
                                <!-- <p>{{ method.streetLine1 }}</p> -->
                                <!-- <p>{{ method.streetLine2 }}</p> -->
                                <p>{{ method.city }}</p>
                                <p>{{ method.province }}</p>
                                <p>{{ method.postalCode }}</p>
                                <p>{{ method.country.name }}</p>
                                <p>{{ method.phoneNumber }}</p>
                            </span>
                        </vsf-radio-card>
                    }
                </div>
            </vsf-radio-card-fieldset>
        </div>
    }

    <div *transloco="let t; prefix: 'checkout.recepient'" class="">
        <h2 class="text-lg font-medium break-words text-gray-900">
            {{ t('title') }}
        </h2>
        <form [formGroup]="contactForm" (focusout)="onCustomerFormBlur()">
            <div class="mt-2 pt-1 grid grid-cols-1 lg:gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                @if (activeCustomer$ | async; as customer) {
                    @if (customer.customFields?.isCompany) {
                        <div class="sm:col-span-2">
                            <label
                                htmlFor="firstName"
                                class="block text-sm font-medium break-words text-gray-700"
                            >
                                {{ t('form.companyName.label') }} <span class="text-red">*</span>
                            </label>
                            <div class="mt-1">
                                <input
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    autoComplete="organization"
                                    formControlName="firstName"
                                    class="input-base block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-sm"
                                />
                            </div>
                        </div>
                    } @else {
                        <div class="">
                            <label
                                htmlFor="firstName"
                                class="block text-sm font-medium break-words text-gray-700"
                            >
                                {{ t('form.firstName.label') }} <span class="text-red">*</span>
                            </label>
                            <div class="mt-1">
                                <input
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    autoComplete="given-name"
                                    formControlName="firstName"
                                    class="input-base block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-sm"
                                />
                            </div>
                        </div>
                        <div class="">
                            <label
                                htmlFor="lastName"
                                class="block text-sm font-medium break-words text-gray-700"
                            >
                                {{ t('form.lastName.label') }}
                            </label>
                            <div class="mt-1">
                                <input
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    autoComplete="family-name"
                                    formControlName="lastName"
                                    class="input-base block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-sm"
                                />
                            </div>
                        </div>
                    }
                } @else {
                    <div class="">
                        <label
                            htmlFor="firstName"
                            class="block text-sm font-medium break-words text-gray-700"
                        >
                            {{ t('form.firstName.label') }} <span class="text-red">*</span>
                        </label>
                        <div class="mt-1">
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                autoComplete="given-name"
                                formControlName="firstName"
                                class="input-base block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-sm"
                            />
                        </div>
                    </div>
                    <div class="">
                        <label
                            htmlFor="lastName"
                            class="block text-sm font-medium break-words text-gray-700"
                        >
                            {{ t('form.lastName.label') }}
                        </label>
                        <div class="mt-1">
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                autoComplete="family-name"
                                formControlName="lastName"
                                class="input-base block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-sm"
                            />
                        </div>
                    </div>
                }
            </div>
            <div class="mt-4 pt-1 grid grid-cols-1 lg:gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                <div class="sm:col-span-2">
                    <label
                        htmlFor="emailAddress"
                        class="block text-sm font-medium break-words text-gray-700"
                    >
                        {{ t('form.emailAddress.label') }} <span class="text-red">*</span>
                    </label>
                    <div class="mt-1">
                        <input
                            type="email"
                            id="emailAddress"
                            name="emailAddress"
                            autoComplete="email"
                            formControlName="emailAddress"
                            class="input-base block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 text-sm"
                        />
                    </div>
                </div>
            </div>
        </form>

        <vsf-address-form #addressForm
                            (focusout)="onAddressFormBlur(addressForm.addressForm)"
                            [address]="shippingAddress$ | async"
                            [availableCountries]="availableCountries$ | async"></vsf-address-form>
    </div>

    @if ((cart$ | async); as cart) {
        <div *transloco="let t; prefix: 'checkout.order'" class="mt-8">
            <h2 class="text-lg font-medium break-words text-gray-900 mb-2">
                {{ t('title') }}
            </h2>
            <div class="summary">
                <vsf-cart-contents [cart]="cart" [isCompany]="(isCompany$ | async)" class="mb-3"></vsf-cart-contents>
                @if (cart.shippingAddress?.streetLine1) {
                    <vsf-address-card
                        class="w-48 block"
                        [title]="t('shippingAddress')"
                        [address]="cart.shippingAddress"
                    >
                        @if ((activeStage$ | async) === 3) {
                            <button class="border border-gray px-2 py-1 mt-2 rounded text-sm hover:bg-gray-100" (click)="changeShippingAddress()">Change</button>
                        }
                    </vsf-address-card>
                }
            </div>
        </div>
    }

    <div class="mt-8">
        <h2 *transloco="let t; prefix: 'checkout'" class="text-lg font-medium break-words text-gray-900">
            {{ t('shippingAddress.title') }}
        </h2>

        @let isAddressFormValid = (isAddressFormValid$ | async) ?? false;

        <div class="card-body">
        </div>
        <vsf-radio-card-fieldset
            [idFn]="getId"
            [selectedItemId]="shippingMethodId"
            (selectItem)="setShippingMethod($event.id)"
        >
            <div class="mt-4 sm:gap-x-4 space-y-3">
                @for (method of (eligibleShippingMethods$ | async); track $index) {
                    <vsf-radio-card [item]="method"
                    (click)="( (method.code !== 'DPD_CLASSIC' && method.code !== 'DHL') || isAddressFormValid ) && onShippingMethodSelect(method.code)" 
                    class="block mb-4">
                        <div 
                            [ngClass]="{
                                'border-gray-300': shippingMethodId !== method.id,
                                'border-primary-500': shippingMethodId === method.id,
                                'ring-1 ring-accent': false
                            }"
                            class="relative bg-main rounded-lg flex items-center cursor-pointer focus:outline-none transition-all"
                            *transloco="let t; prefix: 'checkout'"
                        >
                            <div class="mr-4 flex items-start w-full flex-wrap min-w-0">
                                @if (getLogo(method.code); as logoUrl) {
                                    <p-image 
                                        [src]="logoUrl" 
                                        [alt]="method.name"
                                        class="h-7"
                                    ></p-image>
                                }
                                @switch (method.code) {
                                    @case ('Store') {
                                        <span class="sm:text-lg text-base font-medium break-words text-gray-700 ml-2">
                                            {{ t('shippingMethod.pickupFromStore.label') }} &mdash; {{ method.description | stripHtml }}
                                        </span>
                                    }
                                    @case ('DHL') {
                                        <span class="sm:text-lg text-base font-medium ml-2"
                                            [ngClass]="isAddressFormValid ? 'text-gray-700' : 'text-gray-300'"
                                        >
                                            &mdash;
                                            @if (isAddressFormValid){
                                                {{ addressForm.addressForm.value.streetLine1 }} {{ addressForm.addressForm.value.streetLine2 }},
                                                {{ addressForm.addressForm.value.postalCode }}
                                                {{ addressForm.addressForm.value.city }}
                                            } @else {
                                                {{ t('shippingMethod.dhl.addressNotSpecified') }}
                                            }
                                        </span>
                                    }
                                    @case ('DHL_SHOP') {
                                        <div>
                                            <span class="sm:text-lg text-base font-medium break-words text-gray-700 ml-2">
                                                &mdash; {{ t('shippingMethod.dhl.pickupFromStore') }}
                                            </span>
                                        </div>
                                        <div class="flex flex-col lg:flex-row lg:space-x-2 items-start w-full mt-2 mr-12 transition-all duration-300 ease-in-out"
                                            [style.max-height]="shippingMethodId === method.id ? '100px' : '0'"
                                            [style.opacity]="shippingMethodId === method.id ? '1' : '0'"
                                            [style.margin-top]="shippingMethodId === method.id ? '0.5rem' : '0'">
                                                <p-select 
                                                    class="pointer-events-auto w-full lg:w-2/3 drop-down-base"
                                                    styleClass="bg-white border border-gray-300 rounded-md"
                                                    [formControl]="dhlStore" 
                                                    [options]="(dhlStores$ | async) || []" 
                                                    optionLabel="label" 
                                                    optionValue="retailID"
                                                    [placeholder]="(isAddressValid$ | async) 
                                                        ? t('shippingMethod.pickupFromStore.selectStore') 
                                                        : t('shippingMethod.pickupFromStore.postalCodeCountryIncorrect')"
                                                    [loading]="!(dhlStores$ | async) && (isAddressValid$ | async)">
                                                    <ng-template pTemplate="empty">
                                                        <div class="p-2">
                                                            {{ t('shippingMethod.pickupFromStore.noStoresFound') }}
                                                        </div>
                                                    </ng-template>
                                                </p-select>
                                            <p-button 
                                                class="pointer-events-auto w-full lg:flex-1 mt-2 lg:mt-0"
                                                styleClass="button-base"
                                                (click)="showMap(dhlStore.value, 'dhl')">
                                                {{ t('shippingMethod.pickupFromStore.selectOnMap')}}
                                            </p-button>
                                        </div>
                                    }
                                    @case ('DPD_CLASSIC') {
                                        <span class="sm:text-lg text-base font-medium ml-2"
                                            [ngClass]="isAddressFormValid ? 'text-gray-700' : 'text-gray-300'"
                                        >
                                            &mdash;
                                            @if (isAddressFormValid){
                                                {{ addressForm.addressForm.value.streetLine1 }} {{ addressForm.addressForm.value.streetLine2 }},
                                                {{ addressForm.addressForm.value.postalCode }}
                                                {{ addressForm.addressForm.value.city }}
                                            } @else {
                                                {{ t('shippingMethod.dpd.addressNotSpecified') }}
                                            }
                                        </span>
                                    }
                                    @case ('DPD_SHOP') {
                                        <div>
                                            <span class="sm:text-lg text-base font-medium break-words text-gray-700 ml-2">
                                                &mdash; {{ t('shippingMethod.dpd.pickupFromStore') }}
                                            </span>
                                        </div>
                                        <div class="flex flex-col lg:flex-row lg:space-x-2 items-start w-full mt-2 mr-12 transition-all duration-300 ease-in-out"
                                            [style.max-height]="shippingMethodId === method.id ? '100px' : '0'"
                                            [style.opacity]="shippingMethodId === method.id ? '1' : '0'"
                                            [style.margin-top]="shippingMethodId === method.id ? '0.5rem' : '0'">
                                                <p-select 
                                                    class="pointer-events-auto w-full lg:w-2/3 drop-down-base"
                                                    styleClass="bg-white border border-gray-300 rounded-md"
                                                    [formControl]="dpdStore" 
                                                    [options]="(dpdStores$ | async) || []" 
                                                    optionLabel="label" 
                                                    optionValue="parcelShopId"
                                                    [placeholder]="(isAddressValid$ | async) 
                                                        ? t('shippingMethod.pickupFromStore.selectStore') 
                                                        : t('shippingMethod.pickupFromStore.postalCodeCountryIncorrect')"
                                                    [loading]="!(dpdStores$ | async) && (isAddressValid$ | async)">
                                                    <ng-template pTemplate="empty">
                                                        <div class="p-2">
                                                            {{ t('shippingMethod.pickupFromStore.noStoresFound') }}
                                                        </div>
                                                    </ng-template>
                                                </p-select>
                                            <p-button 
                                                class="pointer-events-auto w-full lg:flex-1 mt-2 lg:mt-0"
                                                styleClass="button-base"
                                                (click)="showMap(dpdStore.value, 'dpd')">
                                                {{ t('shippingMethod.pickupFromStore.selectOnMap')}}
                                            </p-button>
                                        </div>
                                    }
                                    @default {

                                    }
                                }
                                <div class="absolute top-0 right-0 flex-shrink-0">
                                    <span class="text-sm font-medium text-blue-600">
                                        +{{ method.priceWithTax | formatPrice }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </vsf-radio-card>
                }
            </div>
        </vsf-radio-card-fieldset>
    </div>
</div>